import getComposerSelectorOptionsObject from '@/redux/selectors/pieveSelectors/lib/getComposerSelectorOptionsObject.js';
import getNormalizedThreadId from '@/redux/selectors/pieveSelectors/lib/getNormalizedThreadId.js';

const getComposerSelectorThreadId = (options) => {
  return getNormalizedThreadId(getComposerSelectorOptionsObject(options)?.threadId);
};

export default getComposerSelectorThreadId;
